import { jwApi } from '@jwplayer/companion-gateway';

import { SessionStore } from '/global-state/session';

export const populateAccountLimits = async () => {
  jwApi('account/limits', 'getAdvertising', {})
    .then(({ data }) => {
      SessionStore.update((s) => {
        s.accountLimits.isAdsStopped = data.ad_count.limit > 0 && !data.enabled;
      });
    })
    .catch(() => {
      // ignore
    });

  jwApi('account/limits', 'getStorage', {})
    .then(({ data }) => {
      SessionStore.update((s) => {
        s.accountLimits.isStorageStopped = (data.vod_size.limit > 0 || data.vod_count.limit > 0) && !data.enabled;
      });
    })
    .catch(() => {
      // ignore
    });

  jwApi('account/limits', 'getStreaming', {})
    .then(({ data }) => {
      SessionStore.update((s) => {
        s.accountLimits.isStreamingStopped = data.vod_size.limit > 0 && !data.enabled;
      });
    })
    .catch(() => {
      // ignore
    });
};
